import { Form } from 'antd';
import type { FormInstance } from 'antd';

/**
 * `Form.useWatch`, reading the form **store** rather than the mounted fields.
 *
 * A plain `useWatch(name, form)` resolves through `getFieldsValue()`, which
 * lists only names with a rendered `Form.Item`. Two kinds of value are
 * invisible to it:
 *
 * - one the form holds with no control of its own, written straight through
 *   `setFieldsValue` — watching it returns `undefined` *forever*;
 * - one whose `Form.Item` is currently unmounted (a collapsed panel, another
 *   tab) — `undefined` until it renders again, even though antd preserves the
 *   value in the store.
 *
 * Both are in the store the whole time and both are submitted by a
 * `getFieldsValue(true)` save path, so a watch that decides what to render from
 * them has to see the same store. `preserve` is what asks for it.
 */
export function useStoreWatch<T = unknown>(
  name: string,
  form: FormInstance,
): T {
  return Form.useWatch(name, { form, preserve: true }) as T;
}

export default useStoreWatch;
